import * as ToastPrimitive from '@radix-ui/react-toast';
import type { ToastProps as DefaultToastProps } from '@radix-ui/react-toast';
import { cva, type VariantProps } from 'class-variance-authority';

import Button from '@/components/Button';
import ToastIcon from '@/components/Toast/ToastIcon';
import { cn } from '@/lib/utils';

const toastVariants = cva(
  'flex items-center justify-between rounded-md border-2 bg-white px-6 py-4 shadow-xl dark:bg-gray-800 dark:text-gray-100',
  {
    variants: {
      variant: {
        default: '',
        info: 'border-sky-500',
        destructive: 'border-red-500',
        success: 'border-green-500',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

type ToastVariantProps = VariantProps<typeof toastVariants>;

export interface ToastProps extends DefaultToastProps, ToastVariantProps {
  text: string;
}

export default function Toast({ className, text, variant, ...toastProps}: ToastProps) {
  return (
    <ToastPrimitive.Root className={cn(className, toastVariants({ variant }))} data-testid="toast" {...toastProps}>
      <ToastPrimitive.Description className="flex items-center pr-4">
        <ToastIcon {...{ variant }} /><span className="pl-2">{text}</span>
      </ToastPrimitive.Description>
      <ToastPrimitive.Close>
        <Button asChild variant={variant}>Dismiss</Button>
      </ToastPrimitive.Close>
    </ToastPrimitive.Root>
  );
}
